import React from 'react';
import { translate } from 'react-i18next';
import { DaySlot } from './Profile';
import BrightnessGraph from '../profiles/BrightnessGraph';

import './schedule.scss';

const Schedule = ({
  t,
  schedule,
  onUpdate,
  ...rest,
}) => (
  <form className="profile-form schedule-form">
    <div className="profile-input-fields">
      <div className="form-group form-input">
        <label htmlFor="name">{t('Name')}}</label>
        <input type="text" name="description" value={schedule.description} onChange={onUpdate} />
      </div>
      <DaySlot day="default" brightness={schedule.settings} {...rest}/>
      <BrightnessGraph brightness={schedule.settings} />
    </div>
  </form>
)

export default translate('profile')(Schedule);



// WEBPACK FOOTER //
// ./src/components/forms/Schedule.js